import { doc, runTransaction } from 'firebase/firestore';
import { auth, db } from '@/firebaseConfig';

function messageError(code, message) {
  return Object.assign(new Error(message), { code });
}

export async function sendNutritionalTicketMessage({ ticketId, content, messageId }) {
  const normalizedContent = typeof content === 'string' ? content.trim() : '';
  if (!normalizedContent || normalizedContent.length > 20000) {
    throw messageError('invalid-argument', 'Scrivi un messaggio di massimo 20.000 caratteri.');
  }
  if (typeof ticketId !== 'string' || !ticketId || ticketId.length > 512 || ticketId.includes('/')) {
    throw messageError('invalid-argument', 'Conversazione non valida.');
  }
  if (typeof messageId !== 'string' || !/^[a-zA-Z0-9_-]{1,128}$/.test(messageId)) {
    throw messageError('invalid-argument', 'Identificativo del messaggio non valido.');
  }
  const userId = auth.currentUser?.uid;
  if (!userId) throw messageError('unauthenticated', 'Accedi per inviare il messaggio.');

  const ticketRef = doc(db, 'tickets', ticketId);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(ticketRef);
    if (!snapshot.exists()) throw messageError('not-found', 'Conversazione non trovata.');
    const ticket = snapshot.data();
    if (ticket.userId !== userId || auth.currentUser?.uid !== userId) {
      throw messageError('permission-denied', 'Non puoi inviare messaggi in questa conversazione.');
    }
    const conversations = Array.isArray(ticket.conversations) ? ticket.conversations : [];
    const existing = conversations.find((message) => message?.id === messageId);
    if (existing) {
      if (existing.type !== 'Richiesta' || existing.content !== normalizedContent) {
        throw messageError('already-exists', 'Questo identificativo appartiene a un altro messaggio.');
      }
      return { message: existing, ticketId };
    }
    if (ticket.status === 'Completato') {
      throw messageError('failed-precondition', 'Conversazione completata. Apri un nuovo ticket.');
    }
    const message = {
      id: messageId,
      type: 'Richiesta',
      content: normalizedContent,
      timestamp: new Date().toISOString(),
      userId,
    };
    transaction.update(ticketRef, {
      conversations: [...conversations, message],
      status: 'Aperto',
    });
    return { message, ticketId };
  });
}
